<template>
  <div class="AddCarServicerInfo">
    <QS-h4-title title="车服人员" />
    <el-form
      :model="formData"
      label-width="140px"
      style="overflow: hidden;"
    >
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item
            prop="managerId"
            :label="`司管姓名${columnSeparator}`"
          >
            <el-select
              v-model="formData.managerId"
              :loading="loading"
              clearable
              filterable
              remote
              placeholder="请输入"
              :remote-method="searchEmployees"
              @clear="searchEmployees('')"
            >
              <el-option
                v-for="item in employeeList"
                :key="item.id"
                :label="getEmployeeLabel(item)"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            prop="vehicleManagerId"
            :label="`车管姓名${columnSeparator}`"
          >
            <el-select
              v-model="formData.vehicleManagerId"
              :loading="loading"
              clearable
              filterable
              remote
              placeholder="请输入"
              :remote-method="searchEmployees"
              @clear="searchEmployees('')"
            >
              <el-option
                v-for="item in employeeList"
                :key="item.id"
                :label="getEmployeeLabel(item)"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { getAllEmployeeList } from '@/api/carManage/index.js'

export default {
  name: 'AddCarServicerInfo',
  props: {
    addFormData: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    addFormData: {
      handler(val = {}) {
        const individualCustomerInfo = val.individualCustomerVo || val.individualCustomerInfo || {}
        this.formData = {
          managerId: this.normalizeId(val.managerId || val.manager?.id),
          vehicleManagerId: this.normalizeId(
            individualCustomerInfo.vehicleManagerId || val.vehicleManager?.id,
          ),
        }
        this.mergeEmployeeOptions([val.manager, val.vehicleManager])
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      formData: {
        managerId: null,
        vehicleManagerId: null,
      },
      employeeList: [],
      loading: false,
    }
  },
  methods: {
    normalizeId(value) {
      if (value === undefined || value === null || value === '') return null
      return value
    },
    getEmployeeLabel(item = {}) {
      return item.userName || item.account || item.userMobile || ''
    },
    mergeEmployeeOptions(list = []) {
      const employeeMap = new Map()
      this.employeeList.forEach((item) => {
        if (item?.id) {
          employeeMap.set(item.id, item)
        }
      })
      list.forEach((item) => {
        if (item?.id) {
          employeeMap.set(item.id, item)
        }
      })
      this.employeeList = Array.from(employeeMap.values())
    },
    searchEmployees(userName = '') {
      if (this.loading) return
      this.loading = true
      getAllEmployeeList({
        userName,
        includeDisabled: 'YES',
      }).then((res) => {
        if (res.code === 1) {
          this.employeeList = []
          this.mergeEmployeeOptions([
            ...(res.data || []),
            this.addFormData.manager,
            this.addFormData.vehicleManager,
          ])
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // eslint-disable-next-line vue/no-unused-properties
    getParams() {
      return {
        managerId: this.formData.managerId,
        vehicleManagerId: this.formData.vehicleManagerId,
      }
    },
  },
  mounted() {
    this.searchEmployees('')
  },
}
</script>

<style lang="scss" scoped>
.AddCarServicerInfo{
  ::v-deep .el-select {
    width: 100%;
  }
}
</style>
